export class RoutePaths {
  static readonly AccessDenied = "/access-denied";
  static readonly EventCatalogue = "/event-catalogue";
  static readonly EventTemplates = "/event-catalogue/templates";
  static readonly EditEventTemplate = "/event-catalogue/templates/:id";
  static readonly CreateEventTemplate = "/event-catalogue/create";
  static readonly Events = "/calendar";
  static readonly CreateEvent = "/calendar/create";
  static readonly EditEvent = "/calendar/events/:id";
  static readonly GenericError = "/500";
  static readonly Home = "/";
  static readonly Notices = "/updates";
  static readonly EditNotice = "/updates/edit/:id";
  static readonly CreateNotice = "/updates/create";
  static readonly ViewNotice = "/updates/view/:id";
  static readonly PageNotFound = "/404";
  static readonly ResidentAdmin = "/resident-admin";
  static readonly IndependentResidentAdmin = "/resident-admin/independent";
  static readonly ServicedApartmentResidentAdmin =
    "/resident-admin/serviced-apartment";
  static readonly Transactions = "/transactions";
  static readonly SignIn = "/sign-in";
  static readonly SpecialDays = "/special-days";
  static readonly Metrics = "/metrics";
  static readonly SpecialDaysCreate = "/special-days/create";
  static readonly SpecialDaysEdit = "/special-days/edit/:id";
  static readonly VillageCalendars = "/manage-village";
  static readonly VillageCalendarsCreate = "/manage-village/create";
  static readonly VillageCalendarsEdit = "/manage-village/edit/:id";
}
